import { c as _c } from "react/compiler-runtime";
import { useTourSortView } from "@website/accommodation-ui/tour-result-header/tour-sort-view/hooks";
import { TourSortViewPropertiesType } from "@website/accommodation-ui/tour-result-header/tour-sort-view/types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { MiniPopover } from "@website/ui/mini-popover";
import { Radio } from "@website/ui/radio";
import { FC } from "react";
export const TourSortView: FC<TourSortViewPropertiesType> = properties => {
  const $ = _c(23);
  const {
    orderBy,
    sorts
  } = properties;
  let t0;
  if ($[0] !== orderBy || $[1] !== sorts) {
    t0 = {
      orderBy,
      sorts
    };
    $[0] = orderBy;
    $[1] = sorts;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    onChangeRadio,
    activeSort,
    toggleOpen,
    open
  } = useTourSortView(t0);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MaterialIcon className="text-sm" name="sort" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = activeSort ? activeSort?.label : "\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC";
  let t3;
  if ($[4] !== t2 || $[5] !== toggleOpen) {
    t3 = <Button StartIcon={t1} color="neutral" onClick={toggleOpen} size="small" variant="round-outline">{t2}</Button>;
    $[4] = t2;
    $[5] = toggleOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== activeSort?.value || $[8] !== onChangeRadio || $[9] !== sorts) {
    let t5;
    if ($[11] !== activeSort?.value || $[12] !== onChangeRadio) {
      t5 = item => <Radio key={item.label} {...item} checked={activeSort?.value === item.value} className="my-3 text-sm" color="secondary" name="radiobutton" onChange={onChangeRadio} />;
      $[11] = activeSort?.value;
      $[12] = onChangeRadio;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    t4 = sorts.map(t5);
    $[7] = activeSort?.value;
    $[8] = onChangeRadio;
    $[9] = sorts;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <div className="flex flex-1 flex-col overflow-hidden"><div className="flex flex-1 overflow-hidden px-3.5"><div className="my-3 text-sm">{t4}</div></div></div>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== open || $[17] !== t5 || $[18] !== toggleOpen) {
    t6 = <MiniPopover defaultHorizontalPosition="end" onClose={toggleOpen} open={open} title={"\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC"}>{t5}</MiniPopover>;
    $[16] = open;
    $[17] = t5;
    $[18] = toggleOpen;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t3 || $[21] !== t6) {
    t7 = <div className="relative">{t3}{t6}</div>;
    $[20] = t3;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};